export default __webpack_public_path__ + "static/media/constitutionalBg@2x.2ec1cb30.png";